import React, { useState, useEffect } from "react";
import { Button, Spin } from "antd";
import toast from "react-hot-toast";
import OtpInput from "react-otp-input";
import { generateOtp, verifyOtp } from "../../modules/auth/services/otpApi";
import "./style.css";

const OTPCodeVerifyContent = ({ email, onVerified }) => {
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [countdown, setCountdown] = useState(300);

  useEffect(() => {
    let interval;
    if (countdown > 0) {
      interval = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [countdown]);

  const formatTime = (sec) => {
    const min = Math.floor(sec / 60).toString().padStart(2, "0");
    const secRemain = (sec % 60).toString().padStart(2, "0");
    return `${min}:${secRemain}`;
  };

  const handleVerifyOtp = async () => {
    if (otp.length !== 6) {
      toast.error("Le code doit contenir 6 chiffres");
      return;
    }

    setLoading(true);
    try {
      const response = await verifyOtp(email, otp);
      if (typeof response === "string" && response.toLowerCase().includes("otp vérifié")) {
        toast.success("Code vérifié ✅");
        onVerified();
      } else {
        toast.error("Code incorrect");
      }
    } catch {
      toast.error("Erreur de vérification");
    } finally {
      setLoading(false);
    }
  };

  const handleResendCode = async () => {
    setLoading(true);
    try {
      await generateOtp(email);
      toast.success("Code renvoyé à votre adresse email.");
      setCountdown(300);
    } catch {
      toast.error("Erreur lors de l'envoi du code");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (countdown === 0) {
      toast.success("Code expiré, merci de demander un autre");
    }
  }, [countdown]);

  const maskEmail = (email) => {
    if (!email || typeof email !== "string") return "";

    const [localPart, domain] = email.split("@");
    if (!localPart || !domain) return email;

    if (localPart.length <= 3) {
      return `${localPart}@${domain}`;
    }

    const visibleStart = localPart.slice(0, 2);
    const visibleEnd = localPart.slice(-1);
    const maskedMiddle = "*".repeat(localPart.length - 3);

    return `${visibleStart}${maskedMiddle}${visibleEnd}@${domain}`;
  };
  
  return (
    <div className="otp-wrapper">
      <h2 className="otp-title mb-2">Finaliser votre inscription</h2>
      <p className="otp-description">
        Un code a été envoyé à <strong>{maskEmail(email)}</strong>
      </p>
      <p className="otp-description">
        Merci de bien vouloir renseigner le code OTP à 6 chiffres que vous avez reçu par mail afin de finaliser votre vérification.
      </p>

      <div className={`otp-timer ${countdown === 0 ? "red" : countdown <= 60 ? "red" : "default"}`}>
        {countdown === 0 ? (
          <strong>⛔ Code expiré</strong>
        ) : (
          <>⏳ Le code expire dans : <strong>{formatTime(countdown)}</strong></>
        )}
      </div>

      <div className="otp-input-container mt-2">
        <OtpInput
          value={otp}
          onChange={setOtp}
          numInputs={6}
          renderInput={(props) => <input {...props} className="otp-input mt-2" />}
        />
      </div>

      <Button
        type="primary"
        className="otp-confirm-button"
        onClick={handleVerifyOtp}
        disabled={loading}
      >
        {loading ? <Spin size="small" /> : "Confirmer"}
      </Button>

      <button
        onClick={handleResendCode}
        className="otp-resend-link"
        disabled={countdown > 0 || loading}
        style={{
          opacity: countdown > 0 ? 0.5 : 1,
          cursor: countdown > 0 ? "not-allowed" : "pointer",
        }}
      >
        Renvoyer le code
      </button>
    </div>
  );
};

export default OTPCodeVerifyContent;
